import { render } from "./sabko-banner.vue?vue&type=template&id=1f95af1a&scoped=true"
import script from "./sabko-banner.vue?vue&type=script&lang=js"
export * from "./sabko-banner.vue?vue&type=script&lang=js"

import "./sabko-banner.vue?vue&type=style&index=0&id=1f95af1a&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f95af1a"]])

export default __exports__